// import React, { useRef } from 'react';
// import { useSelector } from 'react-redux';
// import HomeCard from '../component/HomeCard';
// import CardFeature from '../component/CardFeature';
// import { GrPrevious } from 'react-icons/gr';
// import { GrNext } from 'react-icons/gr';
// import AllProduct from '../component/AllProduct';
// import switchImage from '../asset/switchImage.png';

// function Home() {
//   const productData = useSelector((state) => state.product.productList);
//   const homeProductCartList = productData.slice(0, 4);

//   const homeProductCartListVegetables = productData.filter(
//     (el) => el.category === 'Switches',
//     []
//   );

//   const loadingArray = new Array(4).fill(null);
//   const loadingArrayFeature = new Array(10).fill(null);

//   const slideProductRef = useRef();
//   const nextProduct = () => {
//     slideProductRef.current.scrollLeft += 200;
//   };

//   const preveProduct = () => {
//     slideProductRef.current.scrollLeft -= 200;
//   };

//   return (
//     <div className="p-2 md:p-4">
//       {/* Hero Section */}
//       <div className="md:flex gap-4 py-2">
//         {/* Left Content */}
//         <div className="md:w-1/2">
//           <div className="flex gap-3 bg-slate-300 w-fit px-4 py-2 items-center rounded-full">
//             <p className="text-sm font-medium text-slate-900">Appliances</p>
//             <img src={switchImage} alt="Switch Icon" className="h-7" />
//           </div>
//           <h2 className="text-4xl md:text-7xl font-bold py-3">
//             Home Electric is now a{' '}
//             <span className="text-red-600">Registered Brand</span>
//           </h2>
//           <p className="py-3 text-base">
//             Home Electric and Appliances has rapidly risen in the electrical
//             manufacturing industry. Starting just two years ago with basic
//             electrical holders and SS combined, we've expanded our product
//             range to include switch and sockets, modular metal boxes, fan
//             boxes, light boxes, MCBs, distribution boxes, modular, and
//             non-modular items. Our vision is to be one of India's leading
//             electrical manufacturers, offering quality at an affordable price.
//             Driven by innovation and a customer-centric approach, we pride
//             ourselves on our commitment to excellence and rapid growth. Join us
//             in our journey towards excellence.
//           </p>
//           <button className="font-bold bg-red-500 text-slate-200 px-4 py-2 rounded-md">
//             Order Now
//           </button>
//         </div>

//         {/* Right Content */}
//         <div className="md:w-1/2 flex flex-wrap gap-5 p-4 justify-center">
//           {homeProductCartList[0]
//             ? homeProductCartList.map((el) => {
//                 return (
//                   <HomeCard
//                     key={el._id}
//                     id={el._id}
//                     image={el.image}
//                     price={el.price}
//                     name={el.name}
//                     category={el.category}
//                   />
//                 );
//               })
//             : loadingArray.map((el, index) => (
//                 <HomeCard key={index + 'loading'} loading={'Loading...'} />
//               ))}
//         </div>
//       </div>

//       {/* Switches Section */}
//       <div className="my-4">
//         <div className="flex w-full items-center">
//           <h2 className="font-bold text-2xl text-slate-800 mb-4">Switches</h2>
//           <div className="ml-auto flex gap-4">
//             <button
//               onClick={preveProduct}
//               className="bg-slate-300 hover:bg-slate-400 text-lg p-1 rounded"
//             >
//               <GrPrevious />
//             </button>
//             <button
//               onClick={nextProduct}
//               className="bg-slate-300 hover:bg-slate-400 text-lg p-1 rounded"
//             >
//               <GrNext />
//             </button>
//           </div>
//         </div>

//         {/* Product Slider */}
//         <div
//           className="flex gap-5 overflow-x-scroll scroll-smooth scrollbar-hide transition-all"
//           ref={slideProductRef}
//         >
//           {homeProductCartListVegetables[0]
//             ? homeProductCartListVegetables.map((el) => {
//                 return (
//                   <CardFeature
//                     key={el._id + 'Switches'}
//                     id={el._id}
//                     name={el.name}
//                     category={el.category}
//                     price={el.price}
//                     image={el.image}
//                   />
//                 );
//               })
//             : loadingArrayFeature.map((el, index) => (
//                 <CardFeature
//                   loading="Loading..."
//                   key={index + 'cartLoading'}
//                 />
//               ))}
//         </div>
//       </div>

//       {/* All Products Section */}
//       <AllProduct heading={'Your Product'} />
//     </div>
//   );
// }

// export default Home;



import React, { useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';
import HomeCard from '../component/HomeCard';
import CardFeature from '../component/CardFeature';
import AllProduct from '../component/AllProduct';

import { BsLightningChargeFill, BsShieldFillCheck, BsStarFill } from 'react-icons/bs';
import { HiArrowRight, HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { MdOutlineLocalShipping, MdVerified } from 'react-icons/md';
import { TbCertificate } from 'react-icons/tb';

// ── Animated electric circuit SVG background ────────────────────────────────
function CircuitBg() {
  return (
    <svg
      aria-hidden="true"
      className="absolute inset-0 w-full h-full pointer-events-none select-none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ opacity: 0.18 }}
    >
      <defs>
        <linearGradient id="cg1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%"   stopColor="#6366f1" stopOpacity="1"/>
          <stop offset="100%" stopColor="#00fff0" stopOpacity="1"/>
        </linearGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="2" result="blur"/>
          <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
      </defs>

      {/* Horizontal rails */}
      <line x1="0"    y1="80"  x2="100%"  y2="80"  stroke="url(#cg1)" strokeWidth="0.5"
        strokeDasharray="1000" strokeDashoffset="1000"
        style={{ animation: 'circuitDraw 3s ease forwards 0.3s', fill:'none' }} />
      <line x1="0"    y1="200" x2="100%"  y2="200" stroke="url(#cg1)" strokeWidth="0.5"
        strokeDasharray="1000" strokeDashoffset="1000"
        style={{ animation: 'circuitDraw 3s ease forwards 0.6s', fill:'none' }} />
      <line x1="0"    y1="360" x2="100%"  y2="360" stroke="url(#cg1)" strokeWidth="0.5"
        strokeDasharray="1000" strokeDashoffset="1000"
        style={{ animation: 'circuitDraw 3s ease forwards 0.9s', fill:'none' }} />
      <line x1="0"    y1="500" x2="100%"  y2="500" stroke="url(#cg1)" strokeWidth="0.5"
        strokeDasharray="1000" strokeDashoffset="1000"
        style={{ animation: 'circuitDraw 3s ease forwards 1.1s', fill:'none' }} />

      {/* Vertical rails */}
      <line x1="120"  y1="0" x2="120"  y2="100%" stroke="url(#cg1)" strokeWidth="0.5"
        strokeDasharray="1000" strokeDashoffset="1000"
        style={{ animation: 'circuitDraw 3s ease forwards 0.5s', fill:'none' }} />
      <line x1="340"  y1="0" x2="340"  y2="100%" stroke="url(#cg1)" strokeWidth="0.5"
        strokeDasharray="1000" strokeDashoffset="1000"
        style={{ animation: 'circuitDraw 3s ease forwards 0.8s', fill:'none' }} />
      <line x1="640"  y1="0" x2="640"  y2="100%" stroke="url(#cg1)" strokeWidth="0.5"
        strokeDasharray="1000" strokeDashoffset="1000"
        style={{ animation: 'circuitDraw 3s ease forwards 1.0s', fill:'none' }} />
      <line x1="1000" y1="0" x2="1000" y2="100%" stroke="url(#cg1)" strokeWidth="0.5"
        strokeDasharray="1000" strokeDashoffset="1000"
        style={{ animation: 'circuitDraw 3s ease forwards 1.2s', fill:'none' }} />

      {/* Junction nodes */}
      {[
        [120,80],[340,80],[640,80],[1000,80],
        [120,200],[340,200],[640,200],[1000,200],
        [120,360],[340,360],[640,360],[1000,360],
        [120,500],[340,500],[640,500],[1000,500],
      ].map(([cx,cy],i) => (
        <circle
          key={i}
          cx={cx} cy={cy} r="3"
          fill="url(#cg1)"
          filter="url(#glow)"
          style={{
            animation: `fadeIn 0.3s ease forwards ${1.5 + i * 0.08}s`,
            opacity: 0,
          }}
        />
      ))}
    </svg>
  );
}

// ── Stat item ────────────────────────────────────────────────────────────────
function StatItem({ icon, value, label }) {
  return (
    <div className="flex flex-col items-center gap-1 px-4 first:pl-0 last:pr-0">
      <div className="text-xl mb-1" style={{ color: 'var(--cyan)' }}>{icon}</div>
      <span className="text-2xl font-display font-bold text-gradient">{value}</span>
      <span
        className="text-[0.65rem] font-mono tracking-[0.15em] uppercase"
        style={{ color: 'var(--text-muted)' }}
      >
        {label}
      </span>
    </div>
  );
}

const STATS = [
  { icon: <MdOutlineLocalShipping />, value: '500+',   label: 'Products'    },
  { icon: <TbCertificate />,          value: 'ISI',    label: 'Certified'   },
  { icon: <BsShieldFillCheck />,      value: '2 yr',   label: 'Warranty'    },
  { icon: <BsStarFill />,             value: '4.9★',   label: 'Rating'      },
];

// ── Slider arrows ─────────────────────────────────────────────────────────────
function SliderControls({ onPrev, onNext }) {
  return (
    <div className="flex items-center gap-2">
      <button
        onClick={onPrev}
        className="glass rounded-xl p-2 border border-[var(--glass-border)]
                   hover:border-[var(--indigo)] hover:bg-[var(--indigo-dim)]
                   transition-all duration-200"
      >
        <HiChevronLeft className="text-lg" style={{ color: 'var(--text-secondary)' }} />
      </button>
      <button
        onClick={onNext}
        className="glass rounded-xl p-2 border border-[var(--glass-border)]
                   hover:border-[var(--indigo)] hover:bg-[var(--indigo-dim)]
                   transition-all duration-200"
      >
        <HiChevronRight className="text-lg" style={{ color: 'var(--text-secondary)' }} />
      </button>
    </div>
  );
}

// ── Feature strip items ───────────────────────────────────────────────────────
const FEATURES = [
  { icon: '⚡', title: 'ISI Certified',     desc: 'Every product meets BIS standards'         },
  { icon: '🛡️', title: '2-Year Warranty',  desc: 'Backed by manufacturer guarantee'          },
  { icon: '🚚', title: 'Free Shipping',     desc: 'On orders above ₹999 across India'         },
  { icon: '🔧', title: 'Expert Support',    desc: 'Electrical guidance whenever you need it'  },
];

// ── Component ────────────────────────────────────────────────────────────────
export default function Home() {
  const productData       = useSelector(s => s.product.productList);
  const featuredProducts  = productData.slice(0, 4);
  const switchProducts    = productData.filter(p => p.category === 'Switches');
  const loadArr4          = new Array(4).fill(null);
  const loadArr8          = new Array(8).fill(null);
  const switchRef         = useRef(null);
  const [heroIn, setHeroIn] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setHeroIn(true), 80);
    return () => clearTimeout(t);
  }, []);

  const scroll = (ref, dir) => {
    if (ref.current) ref.current.scrollLeft += dir * 240;
  };

  return (
    <div style={{ background: 'var(--bg-void)' }}>

      {/* ════════════════════════════════════════════════════════════════════
          HERO
          ════════════════════════════════════════════════════════════════════ */}
      <section
        className="relative overflow-hidden bg-grid-pattern bg-grid"
        style={{ minHeight: '92vh', paddingTop: 64 }}
      >
        {/* Circuit SVG */}
        <CircuitBg />

        {/* Ambient blobs */}
        <div className="pointer-events-none absolute"
             style={{ top: '-10%', left: '-5%', width: 700, height: 700,
               background: 'radial-gradient(circle, rgba(99,102,241,0.12) 0%, transparent 70%)',
               filter: 'blur(80px)' }} />
        <div className="pointer-events-none absolute"
             style={{ bottom: '-10%', right: '-5%', width: 600, height: 600,
               background: 'radial-gradient(circle, rgba(0,255,240,0.08) 0%, transparent 70%)',
               filter: 'blur(100px)' }} />

        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 h-full
                        grid md:grid-cols-2 gap-10 items-center py-16 md:py-24">

          {/* ── Left ─────────────────────────────────────────────────────── */}
          <div>
            <div
              className={`transition-all duration-700 ${heroIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              <p className="section-eyebrow mb-4">Registered Indian Brand</p>
            </div>

            <h1
              className={`
                font-display leading-none tracking-tight mb-6
                transition-all duration-700 delay-100
                ${heroIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
              `}
              style={{ fontSize: 'clamp(2.6rem, 6vw, 4.8rem)' }}
            >
              <span style={{ color: 'var(--text-primary)' }}>POWER YOUR</span>
              <br />
              <span className="text-gradient">HOME</span>
              <br />
              <span style={{ color: 'var(--text-primary)' }}>SMARTER</span>
            </h1>

            <p
              className={`
                text-base leading-relaxed max-w-[420px] mb-8
                transition-all duration-700 delay-200
                ${heroIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
              `}
              style={{ color: 'var(--text-secondary)' }}
            >
              Premium ISI-certified electrical appliances — switches, sockets, MCBs
              and more. Quality you can trust, priced for every home.
            </p>

            <div
              className={`
                flex flex-wrap gap-3 mb-12
                transition-all duration-700 delay-300
                ${heroIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
              `}
            >
              <Link to={`/menu/${productData[0]?._id || ''}`}>
                <button className="btn-primary flex items-center gap-2 px-6 py-3 rounded-xl text-xs">
                  <BsLightningChargeFill />
                  Shop Now
                  <HiArrowRight />
                </button>
              </Link>
              <Link to="/about">
                <button className="btn-ghost flex items-center gap-2 px-6 py-3 rounded-xl text-xs">
                  Our Story
                </button>
              </Link>
            </div>

            {/* Stats */}
            <div
              className={`
                flex flex-wrap gap-y-4 divide-x divide-[var(--glass-border)]
                transition-all duration-700 delay-400
                ${heroIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
              `}
            >
              {STATS.map(s => <StatItem key={s.label} {...s} />)}
            </div>
          </div>

          {/* ── Right: featured product grid ──────────────────────────────── */}
          <div
            className={`
              grid grid-cols-2 gap-4
              transition-all duration-700 delay-200
              ${heroIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
            `}
          >
            {(featuredProducts.length ? featuredProducts : loadArr4).map((el, i) =>
              el
                ? <HomeCard key={el._id} id={el._id} image={el.image}
                            price={el.price} name={el.name} category={el.category} />
                : <HomeCard key={i} loading="Loading..." />
            )}
          </div>
        </div>

        {/* Scroll cue */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2
                        animate-bounce opacity-40">
          <span className="font-mono text-[0.6rem] tracking-[0.2em] uppercase"
                style={{ color: 'var(--text-muted)' }}>scroll</span>
          <div style={{ width: 1, height: 32,
            background: 'linear-gradient(180deg, var(--indigo), transparent)' }} />
        </div>
      </section>

      {/* ════════════════════════════════════════════════════════════════════
          FEATURE STRIP
          ════════════════════════════════════════════════════════════════════ */}
      <section className="py-8 px-4 md:px-6 border-y border-[var(--glass-border)]"
               style={{ background: 'var(--bg-deep)' }}>
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4">
          {FEATURES.map(({ icon, title, desc }) => (
            <div
              key={title}
              className="glass-card rounded-2xl px-5 py-4 flex items-start gap-3 card-electric clip-corner"
            >
              <span className="text-2xl mt-0.5 flex-shrink-0">{icon}</span>
              <div>
                <p className="text-sm font-semibold mb-0.5" style={{ color: 'var(--text-primary)' }}>
                  {title}
                </p>
                <p className="text-xs leading-relaxed" style={{ color: 'var(--text-muted)' }}>
                  {desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ════════════════════════════════════════════════════════════════════
          SWITCHES SLIDER
          ════════════════════════════════════════════════════════════════════ */}
      <section className="py-14 px-4 md:px-6" style={{ background: 'var(--bg-void)' }}>
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-7">
            <div>
              <p className="section-eyebrow mb-2">Featured Collection</p>
              <h2 className="font-display text-3xl font-bold" style={{ color: 'var(--text-primary)' }}>
                SWITCHES <span className="text-gradient">RANGE</span>
              </h2>
            </div>
            <SliderControls
              onPrev={() => scroll(switchRef, -1)}
              onNext={() => scroll(switchRef,  1)}
            />
          </div>

          <div
            ref={switchRef}
            className="flex gap-5 overflow-x-auto scroll-smooth no-scrollbar pb-3"
          >
            {(switchProducts.length ? switchProducts : loadArr8).map((el, i) =>
              el
                ? <CardFeature key={el._id + 'sw'} id={el._id} name={el.name}
                               category={el.category} price={el.price} image={el.image} />
                : <CardFeature key={i + 'swLoad'} loading="Loading..." />
            )}
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="divider" />
      </div>

      {/* ════════════════════════════════════════════════════════════════════
          ALL PRODUCTS
          ════════════════════════════════════════════════════════════════════ */}
      <section className="py-14 px-4 md:px-6" style={{ background: 'var(--bg-void)' }}>
        <div className="max-w-7xl mx-auto">
          <AllProduct heading="All Products" />
        </div>
      </section>

      {/* ════════════════════════════════════════════════════════════════════
          TRUST BADGE FOOTER
          ════════════════════════════════════════════════════════════════════ */}
      <section
        className="py-16 px-4 md:px-6"
        style={{ background: 'var(--bg-deep)', borderTop: '1px solid var(--glass-border)' }}
      >
        <div className="max-w-7xl mx-auto text-center">
          <p className="section-eyebrow justify-center mb-4">Why Home Electric</p>
          <h2
            className="font-display text-3xl md:text-4xl font-bold mb-4"
            style={{ color: 'var(--text-primary)' }}
          >
            BUILT ON <span className="text-gradient-hot">TRUST</span>
          </h2>
          <p className="max-w-xl mx-auto text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
            Home Electric started two years ago and has rapidly grown into one of India's most
            reliable electrical brands — driven by quality, transparency, and customer care.
          </p>
          <div className="flex justify-center gap-3 mt-6 flex-wrap">
            {['ISI Certified', 'RoHS Compliant', 'BIS Approved', 'Made in India'].map(tag => (
              <span key={tag} className="badge-cyan">
                <MdVerified className="inline mr-1 text-xs" />{tag}
              </span>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}